import { useMemo } from 'react'
import { getKioskOfflineEnabled } from '../utils/config'
import UserIdleMonitor from '../utils/UserIdleMonitor'

const useIdleMonitor = () => {
  const kioskOfflineEnabled = getKioskOfflineEnabled({ fromAttractLoop: false })

  // add more time when offline
  const IDLE_TIMEOUT_DEFAULT = 60_000 // 1 minute
  const IDLE_TIMEOUT_LONGER = 120_000 // 2 minutes

  const idleMonitorTimeout = useMemo(() => {
    //if kiosk offline is disabled then use env var for timeout just like regular kiosks
    if (!kioskOfflineEnabled) {
      return process.env.REACT_APP_KIOSK_OFFLINE_IDLE_TIMEOUT || IDLE_TIMEOUT_DEFAULT
    }

    if (process.env.REACT_APP_DEV_IDLE_TIMEOUT > IDLE_TIMEOUT_LONGER) {
      return process.env.REACT_APP_DEV_IDLE_TIMEOUT
    }

    //if kiosk offline is enabled then use a higher timeout or 2 minutes minimum
    return IDLE_TIMEOUT_LONGER
  }, [kioskOfflineEnabled])

  const idleMonitor = new UserIdleMonitor(idleMonitorTimeout)

  return { idleMonitor }
}

export default useIdleMonitor
